(function() {
    angular
        .module("dashboard")
        .controller("OrderUpRejectModalController", [
            "$scope",
            "$uibModalInstance",
            "OrderUpOrdersService",
            "orderGuid",
            OrderUpRejectModalController]);

    function OrderUpRejectModalController(
        $scope,
        $uibModalInstance,
        orderUpOrderService,
        orderGuid
    ) {
        $scope.cancel = function() {
            $uibModalInstance.close();
        };
        $scope.decline = function() {
            orderUpOrderService.declineOrder(
                orderGuid,
                $scope.rejectReason);
            $uibModalInstance.close();
        }
        $scope.rejectReason = "Too Busy";
    }
})();
